// extracted by mini-css-extract-plugin
export default {"fullWidth":"On-z","image":"Pn-z","lazyLoadPicture":"Qn-z","lazyLoadSpinner":"Rn-z","lazyLoadSpin":"Sn-z","lazyLoadImage":"Tn-z","hasStyledAspectRatio":"Un-z"};